import "./TotalResultAndFilter.css";
import React, { Fragment, useState } from "react";
import FilterListOutlinedIcon from "@mui/icons-material/FilterListOutlined";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormLabel,
} from "@mui/material";
import useOnclickOutside from "react-cool-onclickoutside";

const TotalResultAndFilter = ({ TotalResults, changeFilters, getFilters }) => {
  let filter = getFilters();
  const setFilters = (fill, val) => {
    let obj = { ...filter };
    if (fill === "leads") obj.show.leads = val;
    else if (fill === "properties") obj.show.properties = val;
    else if (fill === "sharedProperties") obj.show.sharedProperties = val;
    else if (fill === "publicProperties") obj.show.publicProperties = val;
    else if (fill === "agents") obj.show.agents = val;
    else if (fill === "deals") obj.show.deals = val;
    else if (fill === "sort") obj.sort = val;

    changeFilters({ ...obj });
    filter = getFilters();
  };
  const [openFilter, setOpenFilter] = useState(false);
  const outsideClickRef = useOnclickOutside(() => {
    setOpenFilter(false);
  });

  return (
    <Fragment>
      <div className="totalResultFilterContainer">
        <div className="custom-heading">
          Search <span className="resultsTotal">{TotalResults} Results</span>
        </div>
        <div className="filters-toggler" onClick={() => setOpenFilter(true)}>
          <FilterListOutlinedIcon style={{ fill: "rgb(80,80,80)" }} />
          {openFilter && (
            <div
              ref={outsideClickRef}
              className="filterContainer"
              style={{
                position: "absolute",
              }}
            >
              <FormControl>
                <FormLabel id="demo-radio-buttons-group-label">
                  Filters
                </FormLabel>

                <FormControlLabel
                  className="m-0"
                  control={
                    <Checkbox
                      checked={filter?.show?.leads}
                      onClick={() => setFilters("leads", !filter?.show?.leads)}
                    />
                  }
                  label="Clients"
                />
                <FormControlLabel
                  className="m-0"
                  control={
                    <Checkbox
                      checked={filter?.show?.properties}
                      onClick={() =>
                        setFilters("properties", !filter?.show?.properties)
                      }
                    />
                  }
                  label="Inventory Properties"
                />
                <FormControlLabel
                  className="m-0"
                  control={
                    <Checkbox
                      checked={filter?.show?.sharedProperties}
                      onClick={() =>
                        setFilters(
                          "sharedProperties",
                          !filter?.show?.sharedProperties
                        )
                      }
                    />
                  }
                  label="Shared Properties"
                />
                <FormControlLabel
                  className="m-0"
                  control={
                    <Checkbox
                      checked={filter?.show?.publicProperties}
                      onClick={() =>
                        setFilters(
                          "publicProperties",
                          !filter?.show?.publicProperties
                        )
                      }
                    />
                  }
                  label="Public Properties"
                />
                <FormControlLabel
                  className="m-0"
                  control={
                    <Checkbox
                      checked={filter?.show?.agents}
                      onClick={() =>
                        setFilters("agents", !filter?.show?.agents)
                      }
                    />
                  }
                  label="Agents"
                />
                <FormControlLabel
                  className="m-0"
                  control={
                    <Checkbox
                      checked={filter?.show?.deals}
                      onClick={() => setFilters("deals", !filter?.show?.deals)}
                    />
                  }
                  label="Deals"
                />
              </FormControl>
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default TotalResultAndFilter;
